import { ProjectSupportResponseDto } from '../dto/response/project-support-response.dto';
import { ProjectSupportSaveRequestDto } from '../dto/request/project-support-save-request.dto';
import { ProjectSupportUpdateRequestDto } from '../dto/request/project-support-update-request.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class ProjectSupportService extends BaseLandscapeService {
  public async fetchProjectSupportById(
    id: string
  ): Promise<ProjectSupportResponseDto> {
    const response = await this.get<ProjectSupportResponseDto>(
      `/projectsupport/${id}`
    );
    return response.data;
  }

  public async fetchProjectSupportsByProjectId(
    projectId: string
  ): Promise<ProjectSupportResponseDto[]> {
    try {
      const response = await this.get<ProjectSupportResponseDto[]>(
        `/projectsupport/getprojectsupportbyprojectid/${projectId}`
      );
      return response.data;
    } catch (e: any) {
      // The API returns 404 if no support is found in the project
      if (e.response.status === 404) {
        return [];
      }
      return Promise.reject(e);
    }
  }

  public async saveProjectSupport(
    saveRequest: ProjectSupportSaveRequestDto
  ): Promise<ProjectSupportResponseDto> {
    const response = await this.post<ProjectSupportResponseDto>(
      `/projectsupport`,
      saveRequest
    );
    return response.data;
  }

  public async updateProjectSupport(
    updateRequest: ProjectSupportUpdateRequestDto
  ): Promise<ProjectSupportResponseDto> {
    const response = await this.put<ProjectSupportResponseDto>(
      `/projectsupport`,
      updateRequest
    );
    return response.data;
  }

  public async deleteProjectSupport(existingId: string): Promise<void> {
    await this.delete<void>(`/projectsupport/${existingId}`);
  }
}

const projectSupportService = new ProjectSupportService();
export default projectSupportService;
